import AdCore from '../modules/AdCore/';
import AdPause from '../modules/AdPause/';
import AdCorner from '../modules/AdCorner/';
import Events from 'f.core.event';
import Util from 'f.core.mobile.util';

class AdVideo {
    constructor(obj) {
        // this.opt = opt;
        this.init(obj);
        this.pauseflag = false; //是否暂停显示过
        this.cornerflag = false; //是否角标显示过
        // this.hideCornerCount = 15; // 隐藏角标倒计时
        this.cornerTime_hide = 0;

        this.cornerShowFlag = false;
    }

    init(obj) {
        //格式化数据初始化
        this.AdCallback = {
            video_adPositionId: '',
            video_Url: [], // 前贴片mp4数组
            video_Time: [], // 前贴片mp4时长数组
            video_adId: [], // 前贴片adId数组
            totol_Time: 0, // 前贴片总时长
            video_Link: [], // 前贴片跳转数组
            video_Count: [], // 前贴片统计数组
            corner_adPositionId: '',
            corner_Url: '', // 角标图片地址
            corner_Link: '', // 角标跳转地址
            corner_Count: [], // 角标统计数组
            corner_AdId: [], // 角标adId
            corner_HideCount: 15, // 角标隐藏倒计时
            pause_adPositionId: '',
            pause_Url: '', // 暂停图片地址
            pause_Link: '', // 暂停跳转地址
            pause_Count: [], // 暂停统计数组
            pause_AdId: [], // 暂停adId
            test: [], // 测试用
        };
        // debugger;
        console.log(obj); //原始数据

        this.formatData(obj);
        // debugger
        console.log(this.AdCallback); //格式化数据

        var _this = this;

        // if (this.AdCallback.video_Url.length > 0 && this.AdCallback.video_Url[0] != 'undefined') {
        let dui = {
            data: this.AdCallback,
            obj: obj,
        };
        this.can = 'yes';
        this.initParams(dui);
        this.initLayout();
        this.initComponent();
        this.initEvent();
        // } else {
        //     setTimeout(function () {
        //         // debugger
        //         _this.can = 'no';
        //         _this.trigger('ended', 'no');
        //         console.log('trigger=============>', Date.now())
        //     }, 10)

        // }
        console.log(this.can);
    }

    initParams(obj) {
        this.RequestAd = Promise.resolve(obj);
    }

    initLayout() {
        this.el = document.querySelector('.l-video'); //广告外部容器
    }

    initComponent() {
        this.start_play = false; //默认广告未开始播放

        this.cross3 = false; //默认广告播放不超过3秒

        this.AdCore = this.RequestAd.then(call => {
            if (!call.data.video_adPositionId) {
                return null;
            }
            return new AdCore({ data: call.data, obj: call.obj });
        });

        this.AdPause = this.RequestAd.then(call => {
            if (!call.data.pause_adPositionId) {
                return null;
            }
            return new AdPause({ data: call.data, obj: call.obj });
        });

        this.AdCorner = this.RequestAd.then(call => {
            if (!call.data.corner_adPositionId) {
                return null;
            }
            return new AdCorner({ data: call.data, obj: call.obj });
        });

        this.AdCore
            .then(AdCore => {
                if (AdCore) {
                    AdCore.renderTo(this.el);
                }
            })
            .catch(err => {
                console.log(err);
            });

        this.AdPause
            .then(AdPause => {
                if (AdPause) {
                    if (AdPause.type == 'off') {
                        return false;
                    }
                    AdPause.renderTo(this.el);
                    AdPause.hide();
                }
            })
            .catch(err => {
                console.log(err);
            });

        this.AdCorner
            .then(AdCorner => {
                if (AdCorner) {
                    debugger
                    if (AdCorner.type == 'off') {
                        return false;
                    }
                    AdCorner.renderTo(this.el);
                    // AdCorner.hide();
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    initEvent() {
        const AdCore = this.AdCore; // 广告核心
        const AdPause = this.AdPause; // 广告暂停
        const AdCorner = this.AdCorner; // 广告角标

        this.playIndex = 0; //应该播放的index  还有就是可以拿到的AdCore.dom
        let playflag = false; //是否播放过
        let _this = this;
        //超时定时器 大于5秒就gg
        this.time_ad = 0;


        // 1,倒计时 2,查看详情 3,静音 4,广告联播 结束时抛出ended
        AdCore.then(AdCore => {
            if (!AdCore) return;
            _this.setTimer();
            const arrVideo = AdCore.video;
            const adUrl = this.AdCallback.video_Url; // 广告地址数组
            let lastTime = this.AdCallback.totol_Time; // 广告总时长

            // 如果第一个video能播了 原生还不好使 就用的jquery
            $(AdCore.video[0]).on('canplay', () => {
                if (playflag == false) {
                    this.trigger('begin'); //1抛出begin
                    // this.play(0); //this.playIndex
                }
                playflag = true;
            });

            $(AdCore.video[0]).on('error', () => {
                this.trigger('ended', 'no');
            });

            //ios 下不能自动监听到canplay 但是自己play一下就可以监听到了
            // debugger;
            AdCore.video[0].play();

            //广告内容绑定事件 timeupdate ended
            arrVideo.each((index, element) => {
                let first = true; //每一个video的判断
                AdCore.on('timeupdate', () => {
                    // console.log(`element.currentTime${element.currentTime}`);
                    if (element.currentTime > 0 && this.adTimeout) {
                        console.log(`element.currentTime${element.currentTime}`);
                        this.start_play = true;
                        this.trigger('ad_video_start');
                    }

                    if (element.currentTime > 3) {
                        //解决ios播放回退2秒的问题
                        this.cross3 = true; //广告播放超过3秒
                    }

                    if (first == true) {
                        //发送曝光统计
                        let pvurl = this.AdCallback.video_Count[this.playIndex];
                        pvurl.forEach((element, index) => {
                            this.sendCount(element);
                        });
                        // debugger;
                        let _adId = this.AdCallback.video_adId[this.playIndex];
                        let ainfo = this.AdCallback.video_adPositionId + ':' + _adId;
                        _this.trigger('adinfo', { ainfo });
                        first = false;
                    }
                        // console.log(`当前正在播放:: ${this.playIndex}`);
                        // console.log(Math.round(lastTime - element.currentTime))
                    let second = Math.max(0, Math.round(lastTime - element.currentTime));
                    // if(second == 6) debugger
                    AdCore.time.html(second + 's');
                }, element);

                AdCore.on('ended', () => {
                    lastTime = Math.max(0, Math.round(lastTime - element.currentTime));
                    // debugger
                    // console.log(`还剩lastTime::::: ${lastTime}`);
                    console.log(`this.playIndex::::: ${this.playIndex}`);
                    console.log(`arrVideo.length::::: ${arrVideo.length}`);
                    if (arrVideo.length > 0 && this.playIndex + 1 < arrVideo.length) {
                        console.log(`当前是第${this.playIndex}个广告，该播下一个了`);
                        this.play(++this.playIndex); //this.playIndex
                    } else if (this.playIndex + 1 == arrVideo.length) {
                        console.log('广告播完了'); //
                        this.trigger('ended', 'yes');
                    }
                }, element);

                AdCore.on('error', () => {
                    this.trigger('ended', 'no');
                }, element);

                AdCore.on('exit', () => {
                    this.trigger('exit');
                });
            });

            //静音按钮
            Util.tap(AdCore.mute, e => {
                console.log('静音按钮mute');
                AdCore.adVolume();
                return false;
            });

            //查看广告详情 了解详情
            Util.tap(AdCore.more, e => {
                let loc = this.AdCallback.video_adPositionId;
                let id = this.AdCallback.video_adId[this.playIndex];
                _this.trigger('adclick', { loc, id });
                console.log(
                    `查看广告详情:${this.AdCallback.video_Link[this.playIndex]}`,
                );
                // window.open(this.AdCallback.video_Link[this.playIndex]); //核心
                this.trigger(
                    'href_ad',
                    this.AdCallback.video_Link[this.playIndex],
                );
                return false;
            });
        }).catch(err => {
            console.log(err);
        });

        //1,暂停关闭 2,暂停跳转
        AdPause.then(AdPause => {
            if(!AdPause) return;
            if (AdPause.type == 'off') {
                return false;
            }
            //暂停广告的关闭按钮
            Util.tap(AdPause.el, e => {
                console.log('AdPause.el');
                this.trigger('afterAdPause');
                return false;
            });

            //暂停广告的关闭按钮
            Util.tap(AdPause.close, e => {
                console.log('AdPause.close');

                AdPause.hide();
                return false;
            });

            //暂停广告的整体点击
            Util.tap(AdPause.item, e => {
                let loc = this.AdCallback.pause_adPositionId;
                let id = this.AdCallback.pause_AdId;
                _this.trigger('adclick', { loc, id });
                console.log(`AdPause.item ${this.AdCallback.pause_Link}`);

                this.trigger('href_p', this.AdCallback.pause_Link);
                return false;
            });
        }).catch(err => {
            console.log(err);
        });

        //1,角标关闭 2,角标跳转
        AdCorner.then(AdCorner => {
            if(!AdCorner) return;
            if (AdCorner.type == 'off') {
                return false;
            }
            //角标广告的关闭按钮
            Util.tap(AdCorner.close, e => {
                console.log('AdCorner.close');
                clearTimeout(this.cornerTimer);
                this.cornerTimer = null;

                AdCorner.hide();
                return false;
            });

            //角标广告的整体点击
            Util.tap(AdCorner.el, e => {
                let loc = this.AdCallback.corner_adPositionId;
                let id = this.AdCallback.corner_AdId;
                _this.trigger('adclick', { loc, id });
                console.log(`AdCorner.item ${this.AdCallback.corner_Link}`);

                this.trigger('href_c', this.AdCallback.corner_Link);
                return false;
            });
        }).catch(err => {
            console.log(err);
        });

        // this.pauseShow();
        // this.cornerShow();
    }

    //发送统计
    sendCount(url) {
        var img = new Image();
        img.src = url;
        // console.log(url)
    }

    //显示角标图片
    cornerShow() {
        let _this = this;
        if (typeof this.can == 'undefined' || this.can == 'no') return;
        if(this.cornerShowFlag) {
            return;
        }

        this.cornerShowFlag = true;
        this.AdCorner.then(AdCorner => {
            if (!AdCorner) return;
            if (AdCorner.type == 'off') {
                return false;
            }
            AdCorner.show();
            //显示后 15s后自动关闭
            this.cornerTimer = setInterval(() => {
                let seconds = this.AdCallback.corner_HideCount;
                // debugger
                console.log(`隐藏角标倒计时=============>${seconds - this.cornerTime_hide}`);

                if (this.cornerTime_hide == seconds) {
                    console.log('正在隐藏红包');
                    AdCorner.hide();
                    // this.hasHide = true;//红包出现后隐藏
                    clearInterval(this.cornerTimer);
                    this.cornerTimer = null;
                }
                this.cornerTime_hide++;
            }, 1000);
            //就显示一次
            if (this.cornerflag == false) {
                // debugger;
                // 发送曝光统计
                let pvurl = this.AdCallback.corner_Count[0]; //这里面是数组
                pvurl.forEach((element, index) => {
                    this.sendCount(element);
                });

                let _adId = this.AdCallback.corner_AdId;
                let ainfo = this.AdCallback.corner_adPositionId + ':' + _adId;
                _this.trigger('adinfo', { ainfo });
                this.cornerflag = true;
            }
        });
    }

    //显示暂停图片
    pauseShow() {
        let _this = this;
        if (typeof this.can == 'undefined' || this.can == 'no') return;
        this.AdPause.then(AdPause => {
            if (!AdPause) return;
            if (AdPause.type == 'off') {
                return false;
            }
            AdPause.show();
            //就显示一次
            if (this.pauseflag == false) {
                //发送曝光统计
                let pvurl = this.AdCallback.pause_Count[0]; //这里面是数组
                pvurl.forEach((element, index) => {
                    this.sendCount(element);
                });

                let _adId = this.AdCallback.pause_AdId;
                let ainfo = this.AdCallback.pause_adPositionId + ':' + _adId;
                _this.trigger('adinfo', { ainfo });
                this.pauseflag = true;
            }
        });
    }

    //隐藏暂停图片
    pauseHide() {
        if (typeof this.can == 'undefined' || this.can == 'no') return;
        this.AdPause.then(AdPause => {
            if (!AdPause) return;
            if (AdPause.type == 'off') {
                return false;
            }
            AdPause.hide();
        });
    }

    //更换暂停图片
    changePause(index) {
        if (typeof this.can == 'undefined' || this.can == 'no') return;
        this.AdPause.then(AdPause => {
            if (!AdPause) return;
            if (AdPause.type == 'off') {
                return false;
            }
            AdPause.changeImg(index);
        });
    }

    //更换角标图片
    changeCorner(index) {
        if (typeof this.can == 'undefined' || this.can == 'no') return;

        this.AdCorner.then(AdCorner => {
            if (!AdCorner) return;
            if (AdCorner.type == 'off') {
                return false;
            }
            AdCorner.changeImg(index);
        });
    }

    //插入
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }

    //播放
    play(index) {
        if (!index) {
            index = 0;
        }
        //这里就是包了一层，供外面使用。
        this.AdCore.then(AdCore => {
            if (!AdCore) return;
            //真正走Adcore模块的播放方法
            AdCore.adPlay(index); //playIndex
            this.playIndex = index;
            console.log(`index${index}`);
        });
    }

    pause() {
        //这里就是包了一层，供外面使用。
        return this.AdCore.then(AdCore => {
            if (!AdCore) return;
            AdCore.adPause(this.playIndex); //playIndex
        });
    }

    // 格式化数据
    formatData(obj) {
        obj.forEach((element, index) => {
            let adPositionId = element.adPositionId;
            if (!adPositionId) {
                return false;
            }
            let adMaterials = element.adMaterials;

            switch (adPositionId) {
                case '10018600':
                    //前贴片
                    adMaterials.forEach((element, index) => {
                        //adConditions 1,视频mp4 2,视频时间
                        //adAction 1,跳转链接 2,曝光链接
                        this.AdCallback.video_adPositionId = '10018600';
                        this.AdCallback.video_Url.push(element.adConditions.videourl); //前贴片mp4
                        this.AdCallback.video_Time.push(element.adConditions.videotime); //前贴片时常
                        this.AdCallback.video_Link.push(element.adAction.url); //前贴片跳转
                        this.AdCallback.video_Count.push(element.adAction.pvurl); //前贴片曝光,二维数组
                        this.AdCallback.totol_Time += element.adConditions.videotime; //前贴片总时长
                        this.AdCallback.video_adId.push(element.adId); // 前贴片adId
                    });
                    break;
                case '10018601':
                    //角标
                    //zbphotos 1,横版图 2,竖版图
                    //adAction 1,跳转链接 2,曝光链接
                    this.AdCallback.corner_adPositionId = '10018601';
                    this.AdCallback.corner_Link = adMaterials[0].adAction.url;
                    this.AdCallback.corner_Url = adMaterials[0].zbphotos || [];
                    //不这么写也行，直接.就行 ，这么写主要是突出统计内容是个数组，所以下面这个就是二维数组拉
                    this.AdCallback.corner_Count.push(adMaterials[0].adAction.pvurl);
                    this.AdCallback.corner_AdId.push(adMaterials[0].adId); // 角标adId
                    this.AdCallback.corner_HideCount = adMaterials[0].duration || this.AdCallback.corner_HideCount;
                    break;
                case '10018602':
                    //暂停
                    //zbphotos 1,横版图 2,竖版图
                    //adAction 1,跳转链接 2,曝光链接
                    this.AdCallback.pause_adPositionId = '10018602';
                    this.AdCallback.pause_Link = adMaterials[0].adAction.url;
                    this.AdCallback.pause_Url = adMaterials[0].zbphotos || [];
                    //不这么写也行，直接.就行 ，这么写主要是突出统计内容是个数组，所以下面这个就是二维数组拉
                    this.AdCallback.pause_Count.push(adMaterials[0].adAction.pvurl);
                    this.AdCallback.pause_AdId.push(adMaterials[0].adId); // 角标adId

                    break;
                default:
                    // statements_def
                    break;
            }
        });
    }

    //销毁
    destory() {
        this.AdCore.then(AdCore => {
            if (!AdCore) return;
            AdCore.destory();
        });
    }

    //检测5秒内是否能播放，不能播就不再播
    setTimer() {
        this.adTimeout = setInterval(() => {
            this.time_ad++;
            console.log(`time:${this.time_ad}`);
            if (this.time_ad > 9) {
                clearInterval(this.adTimeout);
                this.trigger('ended', 5);
            }
        }, 1000);
    }

    //清除5s定时器
    clearTimer() {
        if (this.adTimeout) {
            clearInterval(this.adTimeout);
            this.adTimeout = null;
        }
    }

    //解决iOS在播放1-3秒之间跳出后回来 广告卡死的问题
    replay(index) {
        if (!index) {
            index = 0;
        }
        //这里就是包了一层，供外面使用。
        this.AdCore.then(AdCore => {
            if (!AdCore) return;
            //真正走Adcore模块的播放方法
            AdCore.adLoad(index);
            AdCore.adPlay(index); //playIndex
            this.playIndex = index;
            console.log(`index${index}`);
        });
    }

    skip(index) {
        if (!index) {
            index = 0;
        }
        //这里就是包了一层，供外面使用。
        this.AdCore.then(AdCore => {
            //真正走Adcore模块的播放方法
            if (!AdCore) return;
            const arrVideo = AdCore.video;
            console.log(arrVideo, index);
            console.log(arrVideo[index].currentTime);
            arrVideo[index].currentTime = 2;
            console.log(arrVideo[index].currentTime);
        });
    }
}

Events.mixTo(AdVideo);
module.exports = AdVideo;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/lib/advideo.js